import { useContext } from 'react';
import { PasswordContext } from '@/features/password';

export const usePasswordInfo = () => {
  const context = useContext(PasswordContext);
  return context;
};
